// Static blog content — served client-side.
export const BLOG_POSTS = [
  {
    slug: 'ai-boom-oil-shock-crash',
    title: 'Could the AI Boom be One Oil Shock Away from Crashing?',
    author: 'Neil Prabhu',
    date: '2026-05-24',
    tag: 'Markets',
    readingTime: 6,
    preview:
      "History repeats. When speculators pile into hyped names on borrowed money, one macro shock can undo years of gains. Here's why an oil-driven AI-stock unwind may already be closer than most people think.",
    body: [
      { type: 'h2', text: 'Introduction' },
      { type: 'p', text: "Let me ask you a question: Do you recall the stock market crash in 2000-2002? They called it the dot-com bubble — tech and the internet were overhyped, and it crashed. History repeats itself over time, and stock market trends recur on many occasions where a breakthrough occurs. For instance, we are all hearing conversations about the big AI-tech startups like Nvidia, or we hear about websites that very few knew about in 2023 becoming the new breakthrough — like the internet today." },
      { type: 'p', text: "I think that most people we see today are just speculators. They only want to put their money in the stocks that profit or are hyped, but the question is — do they earn the profit after liquidating? They're just gambling their money. Usually, periods of hype often lead investors to ignore warning signs and join them." },

      { type: 'h2', text: 'What will history teach you?' },
      { type: 'p', text: "In school, I chose history over geography. My parents thought of it being too complex and boring, but I thought every event that I learned in history — whether it was empires becoming overconfident, societies chasing sudden wealth, or people following crowds during moments of fear and excitement — history repeats itself in different forms. Technology changes, but human psychology stays surprisingly similar." },
      { type: 'p', text: "Well, my theory isn't about history repeating itself. It's about this: I envisage that there will be an AI stock market crash by the end of 2026, and it is because of 2 big reasons." },

      { type: 'h2', text: 'The Theory' },
      { type: 'p', text: "As we know today, the US-Iran war has had a significant impact on the world's economy. Oil prices have skyrocketed, and LPG gas cylinders are scarce. Due to the climb of oil prices, numerous countries are in a crisis. For instance, the Philippines is in a lockdown due to the escalation in oil prices, and the same is occurring for India." },
      { type: 'p', text: "After the increase, countries are facing issues like debt and can't cope with the prices, so they need to raise interest rates. It looks like the speculators that use debt to buy stocks would need to liquidate the stocks, and the sell-off of the overhyped AI stocks would lead to their fall." },
      { type: 'p', text: "When we sell a stock, its market cap reduces because market cap is: Number of outstanding shares × Share Price. The sells will climb to millions and the market cap will reduce and reduce, and finally its peak price is gone." },

      { type: 'h2', text: 'Stock Ownership' },
      { type: 'p', text: "I'll give you an example. My stocks on my app TeenVest — which doesn't require real money — have profited, and they're all AI stocks. I bought them all when they were considered at a 'margin of safety' and then made immense profits. Now I assume that they'll grow more and reach their peak after a few more months. Instead of selling them, I'd keep them long-term and hold even after the crash — and I would buy more shares." },

      { type: 'h2', text: 'Conclusion' },
      { type: 'p', text: "Here's my advice: never lose your mind during this time of a crash if you own stocks with real money. For teenagers reading this — or people who are unsure about investing in stocks — always TeenVest." },
    ],
  },

  {
    slug: 'why-schools-should-teach-investing',
    title: 'Why Schools Should Teach Investing',
    author: 'TeenVest Editorial',
    date: '2026-05-30',
    tag: 'Investing Basics',
    readingTime: 4,
    preview:
      "Twelve years of school and most students still can't tell a P/E ratio from a phone number. Here's the case for putting personal finance in the curriculum before graduation, not after.",
    body: [
      { type: 'h2', text: 'The gap' },
      { type: 'p', text: 'Every student learns the quadratic formula. Very few learn how compound interest actually works, why credit-card debt is the fastest wealth destroyer of a lifetime, or how to read an income statement.' },
      { type: 'h2', text: 'The consequence' },
      { type: 'p', text: 'The result is a generation that meets money for the first time when a paycheck lands — and often through trial and error, with real dollars on the line. That is the most expensive way to learn a subject.' },
      { type: 'h2', text: 'What good financial education looks like' },
      { type: 'p', text: 'It looks less like memorising terms and more like practicing decisions. Virtual portfolios. Simulated crashes. Case studies of real companies. Debating whether a stock is expensive. In short — the way TeenVest teaches.' },
    ],
  },

  {
    slug: 'gambling-vs-investing',
    title: 'Gambling vs Investing',
    author: 'TeenVest Editorial',
    date: '2026-05-16',
    tag: 'Psychology',
    readingTime: 3,
    preview:
      "Same screens, same tickers, same dopamine. So what actually separates a gambler from an investor? One word: time.",
    body: [
      { type: 'h2', text: 'The dopamine trap' },
      { type: 'p', text: 'Gamblers and investors both stare at green and red numbers. The brain does not distinguish. What separates them is the timeframe they are optimising for.' },
      { type: 'h2', text: 'The gambler' },
      { type: 'p', text: 'A gambler plays for the next hour. Their edge, if any, comes from luck. Their process is emotional and reactive.' },
      { type: 'h2', text: 'The investor' },
      { type: 'p', text: 'An investor plays for the next decade. Their edge comes from patience, temperament and time in the market — not timing the market. The tickers are the same, but the game they are playing is very different.' },
    ],
  },

  {
    slug: 'bull-vs-bear-markets',
    title: 'Bull vs Bear Markets',
    author: 'TeenVest Editorial',
    date: '2026-05-08',
    tag: 'Markets',
    readingTime: 3,
    preview:
      "The zoo of Wall Street explained without the jargon. What actually happens under the hood in bull and bear cycles — and why every generation forgets.",
    body: [
      { type: 'h2', text: 'Bulls' },
      { type: 'p', text: 'A bull market is defined by rising prices, easy credit, and stories that stretch further than the numbers. People feel smart. That feeling is expensive.' },
      { type: 'h2', text: 'Bears' },
      { type: 'p', text: "A bear market is defined by falling prices, tightening credit, and stories that suddenly sound naïve. People feel stupid. That feeling is where the next bull is born — because it is when great businesses go on sale." },
    ],
  },

  {
    slug: 'how-ai-is-changing-finance',
    title: 'How AI is Changing Finance',
    author: 'TeenVest Editorial',
    date: '2026-04-24',
    tag: 'AI',
    readingTime: 5,
    preview:
      "From robo-advisors to earnings-call sentiment models, AI has quietly rewritten the plumbing of Wall Street. Here's what it means for retail investors — and for the next generation learning to trade.",
    body: [
      { type: 'h2', text: 'The plumbing' },
      { type: 'p', text: 'AI now reads every 10-K, every earnings call, and every regulatory filing faster than any analyst team. That has compressed information advantages that used to be worth billions.' },
      { type: 'h2', text: 'The frontier' },
      { type: 'p', text: 'The next edge is understanding — not information. AI can tell you what happened. It struggles to tell you what matters. That gap is where thoughtful human investors still win.' },
      { type: 'h2', text: 'What this means for you' },
      { type: 'p', text: 'For a teenager learning today, the highest-leverage skill is not learning to trade like a robot. It is learning to think in probabilities, understand incentives, and know when a story is more expensive than a business.' },
    ],
  },

  {
    slug: 'why-long-term-investing-wins',
    title: 'Why Long-Term Investing Wins',
    author: 'TeenVest Editorial',
    date: '2026-04-14',
    tag: 'Investing Basics',
    readingTime: 4,
    preview:
      "Compounding is boring for the first ten years and then it eats the world. Here is why doing less, over longer, beats doing more, faster.",
    body: [
      { type: 'h2', text: 'The math' },
      { type: 'p', text: '$1,000 compounding at 10% a year for 40 years is not $5,000. It is $45,259. Time is not one of the variables. Time is THE variable.' },
      { type: 'h2', text: 'The behaviour' },
      { type: 'p', text: 'Every trader in the world knows the math. Almost none can execute it — because human beings are wired to react to short-term noise. The investor who does nothing for a decade will usually beat the trader who does everything.' },
    ],
  },

  {
    slug: 'understanding-risk',
    title: 'Understanding Risk',
    author: 'TeenVest Editorial',
    date: '2026-04-02',
    tag: 'Psychology',
    readingTime: 4,
    preview:
      "Risk is not what most people think it is. Volatility is not risk. Losing money is not risk. Permanent loss of capital is. Here is how to actually think about it.",
    body: [
      { type: 'h2', text: 'Volatility vs risk' },
      { type: 'p', text: 'A stock that dropped 30% is not necessarily risky. A stock you did not understand before you bought is.' },
      { type: 'h2', text: 'The Buffett definition' },
      { type: 'p', text: '"Risk comes from not knowing what you\'re doing." Read that twice. Real risk is the gap between what you own and what you understand about what you own.' },
    ],
  },

  {
    slug: 'warren-buffett-lessons-for-teens',
    title: 'Warren Buffett Lessons for Teens',
    author: 'TeenVest Editorial',
    date: '2026-03-20',
    tag: 'Investing Basics',
    readingTime: 5,
    preview:
      "Forget the private jets. The Oracle of Omaha's real wealth came from four rules any 15-year-old can adopt. Here they are — in plain English.",
    body: [
      { type: 'h2', text: 'Rule 1: Circle of competence' },
      { type: 'p', text: 'Own businesses you can explain to a friend in one sentence. If you cannot, you do not own it — you are gambling on it.' },
      { type: 'h2', text: 'Rule 2: Margin of safety' },
      { type: 'p', text: 'Never pay full price. Wait for the market to hand you a discount. The market will. It always does — eventually.' },
      { type: 'h2', text: 'Rule 3: Time > timing' },
      { type: 'p', text: 'Buffett\'s best investments were held for decades. Compounding needs patience, not prediction.' },
      { type: 'h2', text: 'Rule 4: Temperament > intelligence' },
      { type: 'p', text: 'IQ is optional. Emotional control is not. If you cannot stay calm when the crowd is panicking, no amount of math will save you.' },
    ],
  },
];
